import React, { useEffect, useRef } from "react";
import { Layout, Menu, Button, Row, Col } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import SvgIcon from "./BG.js";
import logo from "..//../images/Philips Logo.png";
import shield from "..//../images/Philips Shield.svg";
import Contact from "../contactComponent/Contact";
import "..//../Components/App.css";
import Slice from "../carouselComponent/carousel.js";
import { openNotification, getInitials } from "../../utilities.js";
import { CustomAxios } from "../../service/axios.js";
import { setUserDetails, setAccessibleApplications, setSurveyStats } from "../../redux/actions/landingPageAction.js";
import { useDispatch, useSelector } from "react-redux";
import "./LandingPage.css"
import typographyTokens from "../../typotoken.js";


const { Header, Content, Footer } = Layout;

const LandingPage = () => {
  const contactRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.landingPage.userDetails);
  const surveyStats = useSelector((state) => state.landingPage.surveyStats);

  const defaultApplications = ["IT Portal", "Other Applications","Andere Applicatie","Otra Aplicación", "Autre Application","Weitere Anwendungen","其他应用程序","その他のアプリケーション"];
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const refreshToken = queryParams.get("refresh_token");

    if (token && refreshToken) {
      localStorage.setItem("authToken", token);
      localStorage.setItem("refresh_token", refreshToken);
      localStorage.setItem("isAuthenticated", "true");
      navigate("/itux-happiness-survey", { replace: true });
    } else if (!localStorage.getItem("isAuthenticated")) {
      window.location.href = "/login";
    }
  }, [location, navigate]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if(userDetails) return;
      try {
        const response = await CustomAxios("/me", "GET");
        if (response.status === 200) {
          dispatch(setUserDetails(response.data));
          // console.log("User details:", response.data);
        }
      } catch (err) {
        openNotification(
          "error",
          "Failed to fetch user details. Please try again.",
          "custom-notification"
        );
      }
    };

    fetchUserDetails();
  }, [dispatch,userDetails?.email]);

  useEffect(() => {
    const fetchAccessibleApplications = async () => {
        try {
            const response = await CustomAxios("/user-access", "GET");
            if (response.status === 200) {
                const apps = response.data.applications || [];
                dispatch(setAccessibleApplications([...defaultApplications, ...apps]));
            } else {
                dispatch(setAccessibleApplications(defaultApplications));
            }
        } catch (error) {
            console.error("Error loading accessible applications:", error);
            dispatch(setAccessibleApplications(defaultApplications));
        }
    };

    if (userDetails?.email) fetchAccessibleApplications();
}, [dispatch, userDetails?.email]);

  useEffect(() => {
    // Hydrate from sessionStorage immediately (no flash on refresh)
    if (!surveyStats) {
      const cached = sessionStorage.getItem("surveyStats");
      if (cached) {
        try { dispatch(setSurveyStats(JSON.parse(cached))); } catch(e) {}
      }
    }
  }, [dispatch, surveyStats]);

  useEffect(() => {
    const fetchSurveyStats = async () => {
        try {
            const cachedAt = sessionStorage.getItem("surveyStatsTimestamp");
            const CACHE_TTL = 15 * 60 * 1000; // 15 minutes
            if (cachedAt && (Date.now() - Number(cachedAt)) < CACHE_TTL && surveyStats) {
                return; // cache still fresh, skip API call
            }

            const response = await CustomAxios("/survey-stats", "GET");
            if (response.status === 200) {
                dispatch(setSurveyStats(response.data.stats));
                sessionStorage.setItem("surveyStats", JSON.stringify(response.data.stats));
                sessionStorage.setItem("surveyStatsTimestamp", String(Date.now()));
            }
        } catch (error) {
            console.error("Error loading survey stats:", error);
        }
    };

    const token = localStorage.getItem("authToken");
    if (token) fetchSurveyStats();
}, [dispatch]);

  const scrollToContact = () => {
    contactRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Layout class="App" style={{ borderBottom: "1.3px solid rgba(128, 128, 128,0.5)", }}>
      <Header className="App-header" style={styles.header}>
        <Menu  mode="horizontal" style={{ background: "none",borderBottom:"none" }}>
          <div>
            <img src={logo} alt="Logo" className="nav-logo" /></div>
          {/* <Menu.Item key="1">
              <a href="mailto:ituxticketsurveyreports@philips.com?subject=Feedback%20on%20IT%20Happiness%20Survey">
                Share feedback
              </a>
            </Menu.Item> */}
          <Menu.Item key="1" style={{ padding: 0, marginLeft: "14px" }}>
            <button className="contact-button" onClick={scrollToContact}>
              Contact Us
            </button>
          </Menu.Item>


        </Menu>

        <div style={styles.userCircle}>
          {getInitials(userDetails?.name || "Unknown User")}
        </div>
      </Header>

      <Content class="content" >
        <Row class="full-height-row" align="middle" justify="center">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h3 style={typographyTokens.HeadingMBold}>IT Happiness Survey</h3>
            <h1 style={typographyTokens.HeadingXLBold}>Be heard and Impact Change!</h1>
            {surveyStats && <h2 style={typographyTokens.HeadingLBold}>{Number(surveyStats.contributors).toLocaleString()} - Total Survey Contributors</h2>}
            
            <p style={typographyTokens.BodyL}>
              This isn't just another survey—everything you tell us will be used
              to improve your experience with Philips IT. Join us in this
              journey to make Philips IT better.
            </p>
            <Button
              onClick={() => navigate("/lang")}
              style={{
                backgroundColor: "#F27436",
                color: "White",
                fontSize: "13px",
                borderColor: "#F27436",
              }}
              size="large"
              shape="round"
              class="feedback-button"
            >
              Click here to share feedback
            </Button>
            <br />
            <p style={typographyTokens.BodyLBold}> Privacy Notice:</p>
            <p style={typographyTokens.BodyLBook}>
              This survey is not mandatory, but your insight will fuel
              improvements. It's not anonymous, but your feedback will be
              respected and treated in confidence. By selecting 'Share
              Feedback', you agree to our privacy notice.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <SvgIcon
              className="placeholder-img"
              overallHappiness={surveyStats?.overall ? surveyStats.overall + "%" : ""}
              statsDate={surveyStats?.month && surveyStats?.year ? `${surveyStats.month} ${surveyStats.year}` : ""}
              applications={surveyStats?.applications ? surveyStats.applications + "%" : ""}
              services={surveyStats?.services ? surveyStats.services + "%" : ""}
              incidents={surveyStats?.incidents ? surveyStats.incidents + "%" : ""}
              requests={surveyStats?.service_request ? surveyStats.service_request + "%" : ""}
            />
          </Col>
        </Row>
      </Content>

      <div className="feedback-section">
        <h4
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            marginInline: "50px",
          }}
        >
          We Listened and Acted
        </h4>
        <div style={{ paddingLeft: "10px" }}>
          <Slice></Slice>
        </div>
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>

      {/* Footer */}
      <Footer class="footer">
        <div>
          <img src={shield} alt="Footer Logo" class="footer-logo" />
        </div>
        <div class="footer-text">
          <p >Privacy Notice | Terms of Service</p>
          <p >© Koninklijke Philips N.V., 2004 - 2022. All rights reserved.</p>
        </div>
      </Footer>
    </Layout>
  );
};

const styles = {
  header: {
    display: "flex",
    borderBottom: "1.3px solid rgba(128, 128, 128,0.5)",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    padding: "0 2px",
  },
  userCircle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: "#1890ff",
    color: "white",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: "8px",
  },
};


export default LandingPage;
